/* Prefill only the product inquiry; never submit or replace a customer's message. */
(() => {
  const params = new URLSearchParams(location.search);
  const product = params.get('product')?.slice(0, 200);
  const path = params.get('product_url');
  if (!product || !path || !/^\/products\/[a-z0-9-]+(?:\?variant=\d+)?$/.test(path)) return;
  document.querySelectorAll('[data-contact-context]').forEach((context) => {
    const form = context.closest('form');
    const variant = params.get('variant')?.slice(0, 100) || '';
    const sku = params.get('sku')?.slice(0, 100) || '';
    const label = [product, variant === 'Default Title' ? '' : variant, sku].filter(Boolean).join(', ');
    const link = context.querySelector('a');
    link.textContent = label;
    link.href = path;
    context.hidden = false;
    const fields = { Product: product, Variant: variant, SKU: sku, 'Product URL': new URL(path, location.origin).href };
    for (const [name, value] of Object.entries(fields)) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = `contact[${name}]`; input.value = value;
      context.append(input);
    }
    const body = form.querySelector('textarea');
    if (body && !body.value.trim()) body.value = context.dataset.message.replace('__PRODUCT__', label);
  });
})();
